import { Avatar, Box, Button, Card, Typography } from "@mui/material"
import { TEXT_TITLE_COLOR } from "../../../constants/colors"
import { IMAGE_RIDER_PROFILE } from "../../../lib/endpoints/profileImage"
import { useTranslation } from "react-i18next"

interface Props {
    profileUrl: string,
    username: string,
    onConfirm: VoidFunction
}

const CardRiderProfileComponent = ({ onConfirm, profileUrl, username }: Props) => {
    const { t } = useTranslation("global");
    return (
        <Card sx={{ borderRadius: '12px', boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12);', p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
                <Avatar sx={{
                    width: "80px",
                    height: '80px'
                }}
                    src={IMAGE_RIDER_PROFILE + profileUrl}
                />
            </Box>
            <Box sx={{ textAlign: 'center', mt: 1 }}>
                <Typography variant="h6" fontWeight='bold' color={TEXT_TITLE_COLOR}>{username}</Typography>
                <Button onClick={onConfirm} variant="contained" color="secondary" sx={{ textTransform: 'none', color: '#fff', borderRadius: '10px', mt: 1, p: 1, width: '120px' }}>{t("order_page.Assign job")}</Button>
            </Box>
        </Card>
    )
}
export default CardRiderProfileComponent